import styled from 'styled-components'

export const GridMainArea = styled.div<{
    columnCount: number
}>`
    columns: 1 400px;
    column-gap: 20px;
    margin: 20px;
    /* Medium-sized screen breakpoint (tablet, 1050px) */
    @media only screen and (min-width: 65.625em) {
        columns: ${({ columnCount }) =>
            columnCount ? `${columnCount} 400px` : '3 400px'};
    }
`
